import React, {createRef, useEffect, useRef, useState} from 'react';
import {getCompetitions, getTitles} from "../data/data";
import styled from "styled-components";
import {useMemo} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {Image} from "semantic-ui-react";
import {CompetitionCategory} from "./features/competition/CompetitionCategory";
import LetterButton from "./buttons/LetterButton";
import {device} from "../theme";
import {useSearchParams} from "./hooks/useSearchParams";
import useMedia from "./hooks/useMedia";
import {Menu} from "./layout/Menu";

const competitions = getCompetitions();
const allTitles = getTitles();

const backgroundColors = ["#000", "#ebf4f3", "#AAA", "#444"]
const textColors = ["#FFF", "#000", "#000", "#FFF"]

export const Competition = () => {
    const navigate = useNavigate();
    const searchParams = useSearchParams();
    const imageId = searchParams.getParam("imageId");
    const [background, setBackground] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [filtered, setFiltered] = useState([false, false, false, false, false, false])
    const {isMobile} = useMedia();
    const params = useParams();
    const id = params.id;
    const competition = useMemo(() => {
        return competitions.find(c => c.competitionID === id);
    }, [id])
    const titles = useMemo(() => {
            if (imageId) {
                return allTitles.filter(t => t.imageId === imageId);
            }
            return allTitles.filter(t => t.competitionID === id && filtered[+t.award === -1 ? 0 : +t.award]).sort((a,b) => +a.award-(+b.award))
        },
        [id, filtered])
    const extraTitlesExists = useMemo(() => {
        return allTitles.some(t => t.competitionID === id && +t.award === -1);
    }, [id])
    const categories = useMemo(() => [...new Set(titles.map(t => `${t.class}#${t.theme}`))], [titles])
    const categoriesRef = useRef(categories.map(() => createRef()))
    const searchBack = useMemo(() => {
        if (competition) {
            const queryParams = new URLSearchParams("");
            queryParams.set("short", competition.short);
            queryParams.set("year", competition.year);
            queryParams.set("part", competition.part);
            return queryParams.toString();
        }
        return "";
    }, [competition])

    useEffect(() => {
        const t = [...filtered];
        if (searchParams.hasParam("E"))
            t[0] = true;
        if (searchParams.hasParam("G"))
            t[1] = true;
        if (searchParams.hasParam("S"))
            t[2] = true;
        if (searchParams.hasParam(("B")))
            t[3] = true;
        if (searchParams.hasParam(("HM")))
            t[4] = true;
        if (searchParams.hasParam(("A")))
            t[5] = true;
        setFiltered(t);
        if (searchParams.hasParam("BG"))
            changeBackground(+searchParams.getParam("BG"))
    }, [])

    const changeFilter = (key) => {
        const f = [...filtered];
        f[key] = !f[key];
        setFiltered(f);
        searchParams.deleteParam("imageId");
        if (f[key]) {
            switch (key) {
                case 0: searchParams.setParam("E", 1); break;
                case 1: searchParams.setParam("G", 1); break;
                case 2: searchParams.setParam("S", 1); break;
                case 3: searchParams.setParam("B", 1); break;
                case 4: searchParams.setParam("HM", 1); break;
                case 5: searchParams.setParam("A", 1); break;
            }
        } else {
            switch (key) {
                case 0: searchParams.deleteParam("E"); break;
                case 1: searchParams.deleteParam("G"); break;
                case 2: searchParams.deleteParam("S"); break;
                case 3: searchParams.deleteParam("B"); break;
                case 4: searchParams.deleteParam("HM"); break;
                case 5: searchParams.deleteParam("A"); break;
            }
        }
    }

    const changeBackground = (idx) => {
        const newIdx = idx % backgroundColors.length;
        if (newIdx!==background) {
            setBackground(newIdx)
            searchParams.setParam("BG", newIdx);
            console.log("Setting BG", newIdx);
        }
    }

    useEffect(() => {
        setLoaded(true);
    }, [])
    return <>
        <Header>
            <div>
                <a href="https://nsff.no"><Image src={"/resultater/images/logo-darkgreen.png"} alt="Logo" height={"60"}/></a>

            </div>
            <div>
                <Link to={`/?${searchBack}`}>
                {competition?.name}
                </Link>
            </div>
            <div>
                <Link to={"/"}>Tilbake</Link>
            </div>
        </Header>
        <Menu/>
        <Container color={backgroundColors[background]}>
            {false && categories.map((category, index) =>
                <div
                    key={category}
                    onClick={() => categoriesRef.current[index].current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    })}>
                    {category}
                </div>
            )}
            {categories.map((category, index) =>
                <CompetitionCategory innerRef={categoriesRef.current[index]}
                                     key={category}
                                     titles={titles}
                                     category={category}
                                     textColor={textColors[background]}
                                     finishedLoaded={loaded}
                />
            )}
        </Container>
        <Filter>
            {extraTitlesExists &&
                <LetterButton active={filtered[0]}
                              onClick={() => changeFilter(0)}>{isMobile ? "E" : "Ekstra"}</LetterButton>
            }
            <LetterButton active={filtered[1]}
                          onClick={() => changeFilter(1)}>{isMobile ? "G" : "Gull"}</LetterButton>
            <LetterButton active={filtered[2]}
                          onClick={() => changeFilter(2)}>{isMobile ? "S" : "Sølv"}</LetterButton>
            <LetterButton active={filtered[3]}
                          onClick={() => changeFilter(3)}>{isMobile ? "B" : "Bronse"}</LetterButton>
            <LetterButton active={filtered[4]} onClick={() => changeFilter(4)}>{isMobile ? "H" : "Hederlig"}</LetterButton>
            <LetterButton active={filtered[5]}
                          onClick={() => changeFilter(5)}>{isMobile ? "A" : "Antatt"}</LetterButton>

            <LetterButton active={true}
                          onClick={() => changeBackground(background+1)}>{isMobile ? "BG" : "Bakgrunn"}</LetterButton>
        </Filter>
    </>
}

const Container = styled.div`
  background-color: ${(p) => p.color};
  min-height: 100vh;
`

const Filter = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;

  @media ${device.mobile} {
    flex-direction: row;
  }
`

const Header = styled.div`
  height: 70px;
  background-color: #90b361;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #36501c;
  font-family: 'Fibon Neue';
  
  > div {
    display: flex;
    flex-direction: row;
    margin-left: 10px;

    > div {
      margin-left: 20px;
    }

    >a {
      color: ${(p) => p.theme.color.primary.base};
    }

    align-items: center;
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 1.4rem;
  }

  > div:nth-child(3) {
    margin-right: 20px;
    >a {
      color: ${(p) => p.theme.color.primary.base};
    }
  }
`